import React from 'react'
import { Link } from 'react-router-dom'

import ActivityContentToolTip from 'components/ActivityContentTooltip'
import { ActivityGroupByEndUser, CompanyData, Insight } from 'modules/accountActivity/domain'
import { accountPath, contactPath } from 'utils/paths'
import { segmentTrack, TrackType } from 'utils/tracking'

import styles from './styles.module.css'

interface ActivitySummaryProps {
  insight: Insight
  accountName: string
  activityByEndUser: ActivityGroupByEndUser[]
  companyData: CompanyData
}

const ActivitySummary: React.FC<ActivitySummaryProps> = ({
  insight,
  accountName,
  activityByEndUser,
  companyData
}) => {
  const firstContact =
    activityByEndUser.find(contact => contact.name || contact.email) || activityByEndUser?.[0]

  const contactData = firstContact?.endUserData || firstContact

  const displayName = contactData?.name || contactData?.email || 'Site visitor'

  const secondaryInfo =
    contactData?.role ||
    (contactData?.locationCity && `${contactData?.locationCity}, ${contactData?.locationState}`)

  const numberOfOthers = activityByEndUser.length - 1

  return (
    <div className={styles.activitySummary}>
      <ActivityContentToolTip data={firstContact}>
        <Link
          onClick={() =>
            segmentTrack(TrackType.INSIGHT_FEED_VIEW_CONTACT, {
              insightId: insight.id,
              accountId: insight.accountId,
              contactId: contactData?.id || activityByEndUser[0].endUserId
            })
          }
          to={contactPath(contactData?.id || activityByEndUser[0].endUserId)}>
          <span className={styles.displayName}>{displayName}</span>
        </Link>
      </ActivityContentToolTip>
      {secondaryInfo && ` (${secondaryInfo})`}
      {numberOfOthers > 0 && (
        <span>
          {' '}
          and {numberOfOthers} other{numberOfOthers > 1 && 's'}
        </span>
      )}
      {' from '}
      <ActivityContentToolTip data={companyData}>
        <Link
          className={styles.displayName}
          to={accountPath(insight.accountId)}
          onClick={() => {
            segmentTrack(TrackType.INSIGHT_FEED_VIEW_ACCOUNT, {
              insightId: insight.id,
              accountId: insight.accountId
            })
          }}>
          {accountName}
        </Link>
      </ActivityContentToolTip>
      <span> {activityByEndUser.length > 1 ? 'were' : 'was'} active on your site.</span>
    </div>
  )
}

export default ActivitySummary
